export const EXPANDABLE_SECTION_KEYS = {
  STATION_KPI: 'stationKpi',
  PRESSURE_DROP: 'pressureDrop',
};
